import ReactSelect from "react-select";
import { useEffect, useState } from "react";
import i18next from 'i18next'
import { changeLanguage } from "@services/admin.fixransomware.com/client";
import { isRequestorHasToken, setAcceptLanguage } from "@services/admin.fixransomware.com";
import { languageList } from "@data/language-list";






export function SelectLanguageOptionFull(){

  function handleOnChange(e: {image: any, label: string, value: "en" | "id"} ){

    i18next.changeLanguage(e.value);
    setAcceptLanguage(e.value);
    // change language for this user

    const isTokenExists = isRequestorHasToken();
    if(!isTokenExists) return;

    // change language service can only be called when user has initialized
    changeLanguage(e.value);
  }

  function getDefaultValue(){
    if(i18next.resolvedLanguage === "en") return languageList[0]
    if(i18next.resolvedLanguage === "id") return languageList[1]
    if(i18next.resolvedLanguage === "ar") return languageList[2] 
    if(i18next.resolvedLanguage === "es") return languageList[3]
    if(i18next.resolvedLanguage === "hi") return languageList[4]
    if(i18next.resolvedLanguage === "ko") return languageList[5]
    if(i18next.resolvedLanguage === "zh") return languageList[6]
    if(i18next.resolvedLanguage === "th") return languageList[7]
    if(i18next.resolvedLanguage === "jp") return languageList[8]
  }

  return (
    <ReactSelect
      key={i18next.resolvedLanguage}
      className="z-30 bg-transparent cursor-pointer"
      components={{ DropdownIndicator: () => null }}
      // @ts-expect-error should be fine
      onChange={handleOnChange}
      options={languageList}
      // defaultValue={i18next.resolvedLanguage === "id" ? languageList[1] : languageList[0]}
      defaultValue={getDefaultValue()}  
      isSearchable={false}
      formatOptionLabel={language => (
        <div className="inline-flex gap-2 text-primary">
          <img 
            src={language.image} 
            alt="language-image"  
            className="max-h-[20px]" 
          />
          <span>{language.label}</span>
        </div>
      )}
      data-testid="language-changeLanguage-select"
    />
  )
}

